import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { QuestionResult } from '../services/contents/medq-contents.client';

export type AsyncOperation<T> = Readonly<{
  isLoading: boolean;
  data?: T;
}>

export enum EnumStatusComments {
  NOT_EXISTS = 'notExists',
  EXISTS = 'exists',
  HAS_DOUBT = 'hasDoubt',
  NOT_HAS_DOUBT = 'notHasDoubt'
}

export enum AnswerFilter {
  NEVER_ANSWERED = 'NeverAnswered',
  ANSWERED = 'Answered',
  ONLY_CORRECT_ANSWERS = 'OnlyCorrectAnswers',
  ONLY_WRONG_ANSWERS = 'OnlyWrongAnswers'
}

export enum RoutineDayEnum {
  rest = 'rest',
  review = 'review',
  study = 'study',
}

export enum COMMOM_SORT_ENUM {
  _ID_ASC = '_ID_ASC',
  _ID_DESC = 'ID_DESC'
}

export interface CommomFilter {
  _id?: string;
  _ids?: string[];
  AND?: CommomFilter[];
  OR?: CommomFilter[];
}

export interface CommomFind {
  filter?: CommomFilter;
  skip?: number;
  limit?: number;
}

export enum SORT_ENUM {
  ASC = 1,
  DESC = -1,
}

export enum ActivitySourceEnum {
  system = 'system',
  user = 'user',
  course = 'course',
  analytics = 'analytics',
}

export enum ActivityTypeEnum {
  Question = 'Question',
  MockExam = 'MockExam',
  Flashcard = 'Flashcard',
  Exam = 'Exam',
  Leveling = 'Leveling',
}

export enum SORT_ACTIVITY_ENUM {
  CREATEDAT_ASC = 'CREATEDAT_ASC',
  CREATEDAT_DESC = 'CREATEDAT_DESC',
  UPDATEDAT_ASC = 'UPDATEDAT_ASC',
  UPDATEDAT_DESC = 'UPDATEDAT_DESC',
}

export interface BadgeInterface {
  icon: IconProp;
  name: string;
  description: string;
  value: string;
  priority: number;
}

export interface ActivityData {
  _id: string;
  icon?: string | null;
  author?: string;
  badges?: BadgeInterface[];
  source?: ActivitySourceEnum;
  subtitle?: string | null;
  title: string;
  finished: boolean;
  createdAt?: string;
  updatedAt?: string;
  showAt?: string;
  hideAt?: string;
  type?: ActivityTypeEnum;
  percentSolved?: number;
}

export interface AnswersProportionInterface {
  answerIndex: number;
  count: number;
}

export interface AnswerInterface {
  _id: string;
  author: string;
  createdAt: string;
}

export interface AnswerQuestionInterface {
  choosen: number;
}

export type Question = QuestionResult & {
  subjectNames: string[];
  resumeUrl: string;
}

export enum QuestionDifficulty {
  EASY = 'EASY',
  MEDIUM = 'MEDIUM',
  HARD = 'HARD',
  UNKNOWN = 'UNKNOWN'
}

export interface QuestionSolutionInterface {
  answer: AnswerQuestionInterface | null;
  preChoice?: number | null;
  question: string;
  removedAnswers: number[];
  visited: boolean;
}

export interface FlashcardSolutionInterface {
  answer?: AnswerInterface;
  flashcard: string;
  correct?: boolean;
  visited: boolean;
}

export interface InstitutionInterface {
  name: string;
  region: string;
  exams: string[];
}

export interface ExamTemplateInterface {
  complement: string;
  type: string;
  year: number;
  questions: string[];
  institution: InstitutionInterface;
}

export interface MockExamRankingInfo {
  position: number;
  total: number;
  name?: string;
}
